<template>
  <div class="landing-container">
    <!-- 헤더 & 네비게이션 -->
    <nav class="fixed-nav">
      <div class="nav-content">
        <div class="logo">
          <!-- <img src="@/assets/images/logo.png" alt="로고" /> -->
          <span class="logo-text">AI 장사비서</span>
        </div>
        <div class="nav-menu">
          <a href="#service">서비스 소개</a>
          <a href="#success">성공 사례</a>
          <a href="#pricing">요금제</a>
          <a href="#contact">문의하기</a>
        </div>
        <button class="cta-button" @click="$router.push('/aicrm/main')">베타서비스 시작하기</button>
      </div>
    </nav>

    <!-- 히어로 섹션 -->
    <section class="hero-image-section">
      <img
        class="hero-background"
        :src="require('@/assets/images/aicrm/smart-ai-assistant.png')"
        alt="배경 이미지"
      />
    </section>

    <!-- 메인 콘텐츠 섹션 -->
    <section class="main-content-section">
      <div class="content-wrapper">
        <div class="text-content">
          <h1>단골이 늘면 매출이 올라갑니다!<br />AI가 알아서 단골을 만들어드립니다.</h1>
          <h3 style="margin-top: 1.5rem; margin-bottom: 1.5rem">
            바쁜 사장님 대신 고객을 자동으로 관리하고,<br />재방문을 늘려주는 AI 고객관리 서비스!
          </h3>
          <button class="main-cta" @click="$router.push('/aicrm/main')">
            지금 베타서비스 시작하기
          </button>
        </div>
      </div>
    </section>

    <!-- 주요 기능 섹션 -->
    <section class="features-section" id="service">
      <h2>AI 장사비서가 사장님의 단골을 책임집니다!</h2>
      <div class="features-grid">
        <div class="feature-card">
          <div class="feature-icon">
            <img src="@/assets/images/aicrm/feature-phone.png" alt="전화 한 통으로 고객 확보" />
          </div>
          <h3>전화 한 통으로 고객 확보!</h3>
          <p>
            매장 전화번호(015친구번호)로 자동 친구 추가<br />QR코드 브로셔 제공 → 고객이 쉽게 참여
          </p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <img src="@/assets/images/aicrm/feature-robot.png" alt="AI가 단골을 자동 관리" />
          </div>
          <h3>AI가 단골을 자동 관리</h3>
          <p>
            네이버, 배민, 쿠팡이츠, 요기요 리뷰 분석<br />날씨, 고객 방문 빈도, 매출 데이터 기반
            맞춤 메시지 발송
          </p>
        </div>
        <div class="feature-card">
          <div class="feature-icon">
            <img src="@/assets/images/aicrm/feature-graph.png" alt="매출 상승 효과" />
          </div>
          <h3>매출 상승 효과</h3>
          <p>
            매출이 떨어지면 AI가 적절한 할인쿠폰 발행 요청<br />모든 과정 자동화! 시간 절약 + 매출
            증대
          </p>
        </div>
      </div>
    </section>

    <!-- 고객 후기 섹션 -->
    <section class="testimonials-section" id="success">
      <h2>이미 많은 사장님들이 AI 장사비서로 매출을 올리고 있습니다!</h2>
      <div class="testimonials-grid">
        <div class="testimonial-card" v-for="(review, index) in reviews" :key="index">
          <div class="profile-image" :style="{ backgroundImage: `url(${review.image})` }">
            <div v-if="!review.image" class="emoji-fallback">{{ review.emoji }}</div>
          </div>
          <div class="stars">⭐⭐⭐⭐⭐</div>
          <p class="review-text">{{ review.text }}</p>
          <p class="reviewer-name">{{ review.name }}</p>
        </div>
      </div>
      <div class="partner-logos">
        <div v-for="(partner, index) in partners" :key="index" class="partner-logo">
          {{ partner }}
        </div>
      </div>
    </section>

    <!-- 요금제 섹션 -->
    <section class="pricing-section" id="pricing">
      <h2>비용 부담 없이 시작하세요!</h2>
      <div class="pricing-grid">
        <div class="pricing-card basic">
          <h3>기본형</h3>
          <div class="price">월 12만원</div>
          <p class="sub-text">고객 300명 관리</p>
          <ul>
            <li>AI 자동 메시지 발송</li>
            <li>리뷰 분석 리포트 제공</li>
            <li>QR키트 무료 제공</li>
          </ul>
          <button class="pricing-cta" @click="$router.push('/aicrm/main')">
            베타서비스 시작하기
          </button>
        </div>
      </div>
    </section>

    <!-- 프로모션 배너 -->
    <section class="promo-banner">
      <div class="promo-content">
        <p class="urgent">🔥 지금 가입하면 QR키트 무료 제공!</p>
        <p class="limited">⏳ 첫 100명 한정, AI 마케팅 무료 컨설팅 제공!</p>
        <div class="countdown" v-if="timeLeft">
          {{ formatTimeLeft }}
        </div>
      </div>
    </section>

    <!-- 최종 CTA 섹션 -->
    <section class="final-cta">
      <div class="cta-content">
        <h2>바쁜 사장님! AI가 단골을 만들어드립니다.<br />지금 시작하세요!</h2>
        <button class="main-cta" @click="$router.push('/aicrm/main')">베타서비스 시작하기</button>
      </div>
      <div class="cta-image mt-10">
        <!-- <img src="@/assets/images/aicrm/message-animation.gif" alt="AI 자동 메시지 발송 데모" /> -->
        <div class="mock-messages">
          <div class="message-bubble">안녕하세요! 오늘 날씨가 좋네요 ☀️</div>
          <div class="message-bubble">저희 가게 단골 고객님을 위한 특별 쿠폰 보내드립니다 🎁</div>
          <div class="message-bubble">다음에 방문하실 때 보여주시면 10% 할인!</div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: 'AICRMLanding',
  data() {
    return {
      reviews: [
        {
          emoji: '👨‍🍳',
          image: require('@/assets/images/aicrm/owner1.jpg'),
          text: '한 달 만에 단골이 2배 늘었어요! 바빠서 고객관리 못했는데, AI가 다 알아서 해줍니다.',
          name: '김** 사장님 (분식점)',
        },
        {
          emoji: '☕',
          image: require('@/assets/images/aicrm/owner2.jpg'),
          text: '고객 데이터 분석이 정확해서 놀랐어요. 매출도 20% 이상 늘었습니다.',
          name: '이** 사장님 (카페)',
        },
        {
          emoji: '🍚',
          image: require('@/assets/images/aicrm/owner3.jpg'),
          text: '자동으로 메시지가 발송되니 너무 편해요. 고객 반응도 좋습니다!',
          name: '박** 사장님 (한식당)',
        },
      ],
      partners: ['네이버', '배민', '쿠팡이츠', '요기요'],
      timeLeft: 24 * 60 * 60, // 24시간
    }
  },
  computed: {
    formatTimeLeft() {
      const hours = Math.floor(this.timeLeft / 3600)
      const minutes = Math.floor((this.timeLeft % 3600) / 60)
      const seconds = this.timeLeft % 60
      return `${hours}시간 ${minutes}분 ${seconds}초`
    },
  },
  mounted() {
    console.log('Component mounted')
    console.log('Reviews:', this.reviews)
    console.log('Partners:', this.partners)

    this.timer = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--
      }
    }, 1000)
  },
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer)
    }
  },
  errorCaptured(err, vm, info) {
    console.error('Error captured:', err)
    console.error('Component:', vm)
    console.error('Info:', info)
    return false
  },
}
</script>

<style scoped>
.landing-container {
  width: 100%;
  overflow-x: hidden;
}

.fixed-nav {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(5px);
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.nav-content {
  max-width: 1200px;
  margin: 0 auto;
  padding: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.nav-menu a {
  margin: 0 1rem;
  text-decoration: none;
  color: #333;
  font-weight: 500;
}

.hero-image-section {
  width: 100%;
  position: relative;
  overflow: hidden;
  padding-top: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff6e5;
}

.hero-background {
  width: 100%;
  height: auto;
  object-fit: contain;
  max-width: 100%;
  display: block;
  background: #fff6e5;
}

.main-content-section {
  background: linear-gradient(rgba(30, 144, 255, 0.8), rgba(30, 144, 255, 0.9));
  padding: 6rem 2rem;
  color: white;
}

.content-wrapper {
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
}

.text-content {
  max-width: 800px;
  margin: 0 auto;
}

.hero-content h1 {
  font-size: 2.5rem;
  font-weight: bold;
  margin-bottom: 1.5rem;
}

.hero-content h3 {
  font-size: 1.5rem;
  font-weight: normal;
  margin-bottom: 2rem;
}

.main-cta {
  background: #28a745;
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.2rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
}

.main-cta:hover {
  transform: translateY(-2px);
}

.features-section {
  padding: 5rem 2rem;
  background: white;
}

.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.feature-card {
  background: white;
  padding: 2.5rem 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition: transform 0.2s;
  text-align: center;
}

.feature-card:hover {
  transform: translateY(-5px);
}

.feature-icon {
  width: 180px;
  height: 180px;
  margin: 0 auto 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.5rem;
}

.feature-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: transform 0.3s ease;
}

.feature-card:hover .feature-icon img {
  transform: scale(1.1);
}

.feature-card h3 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
  color: #1e90ff;
}

.feature-card p {
  font-size: 1.1rem;
  line-height: 1.6;
  color: #666;
}

.testimonials-section {
  background: #f8f9fa;
  padding: 5rem 2rem;
}

.testimonials-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.testimonial-card {
  background: white;
  padding: 2rem;
  border-radius: 12px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: column;
  align-items: center;
}

.profile-image {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  margin-bottom: 1rem;
  background: #e3f2fd;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  background-size: cover;
  background-position: center;
  border: 3px solid #1e90ff;
}

.emoji-fallback {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e3f2fd;
  border-radius: 50%;
}

.stars {
  color: #ffc107;
  margin-bottom: 1rem;
}

.pricing-section {
  padding: 5rem 2rem;
  background: white;
}

.pricing-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 2rem;
  max-width: 900px;
  margin: 0 auto;
}

.pricing-card {
  background: #e3f2fd;
  padding: 2.5rem 2rem;
  border-radius: 12px;
  text-align: center;
}

.pricing-card ul {
  list-style: none;
  padding: 0;
  margin: 2rem 0;
}

.pricing-card li {
  position: relative;
  padding: 1rem;
  margin: 0.5rem 0;
  background: rgba(255, 255, 255, 0.8);
  border-radius: 8px;
  font-size: 1.1rem;
  color: #333;
  transition: transform 0.2s ease;
}

.pricing-card li:hover {
  transform: translateY(-2px);
  background: white;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.pricing-card li::before {
  content: '✓';
  color: #28a745;
  font-weight: bold;
  margin-right: 8px;
}

.pricing-card .price {
  font-size: 2.5rem;
  font-weight: bold;
  margin: 1.5rem 0;
  color: #1e90ff;
}

.pricing-card .sub-text {
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 1rem;
}

.pricing-card .savings {
  color: #28a745;
  font-weight: bold;
  font-size: 1.1rem;
  margin: 1rem 0;
}

.pricing-cta {
  background: #28a745;
  color: white;
  border: none;
  padding: 1rem 2rem;
  font-size: 1.1rem;
  font-weight: bold;
  border-radius: 8px;
  cursor: pointer;
  width: 100%;
  margin-top: 1.5rem;
  transition: transform 0.2s, background-color 0.2s;
}

.pricing-cta:hover {
  transform: translateY(-2px);
  background: #218838;
}

.promo-banner {
  background: #fff3cd;
  padding: 1rem;
  text-align: center;
}

.urgent {
  color: #ff5733;
  font-weight: bold;
  font-size: 1.2rem;
}

.final-cta {
  background: #d6e9ff;
  padding: 5rem 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-text {
  font-size: 1.5rem;
  font-weight: bold;
  color: #1e90ff;
}

.mock-phone {
  width: 280px;
  height: 560px;
  background: white;
  border-radius: 30px;
  padding: 20px;
  margin-left: 2rem;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.mock-screen {
  background: #f8f9fa;
  height: 100%;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #333;
}

.mock-screen p {
  margin: 10px 0;
  font-size: 1.1rem;
  color: #1e90ff;
}

.partner-logos {
  display: flex;
  justify-content: center;
  gap: 2rem;
  margin-top: 3rem;
  flex-wrap: wrap;
}

.partner-logo {
  background: #f8f9fa;
  padding: 1rem 2rem;
  border-radius: 8px;
  color: #666;
  font-weight: 500;
}

.mock-messages {
  background: white;
  padding: 20px;
  border-radius: 16px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
  width: 300px;
}

.message-bubble {
  background: #e3f2fd;
  padding: 12px 16px;
  border-radius: 12px;
  margin: 8px 0;
  font-size: 0.9rem;
  color: #333;
  animation: fadeIn 0.5s ease-in-out forwards;
  opacity: 0;
}

.message-bubble:nth-child(1) {
  animation-delay: 0.2s;
}
.message-bubble:nth-child(2) {
  animation-delay: 0.7s;
}
.message-bubble:nth-child(3) {
  animation-delay: 1.2s;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .nav-menu {
    display: none;
  }

  .hero-image-section {
    padding-top: 60px;
  }

  .hero-background {
    max-height: calc(50vh - 60px);
  }

  .content-wrapper {
    flex-direction: column;
    text-align: center;
    gap: 3rem;
  }

  .text-content {
    max-width: 100%;
  }

  .mock-phone {
    margin-left: 0;
  }

  .features-grid,
  .testimonials-grid,
  .pricing-grid {
    grid-template-columns: 1fr;
  }

  .final-cta {
    flex-direction: column;
    text-align: center;
  }
}

@media (min-width: 1400px) {
  .hero-background {
    max-width: 1400px;
    width: 100%;
  }
}
</style>
